package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun GestionPatrullasScreen(viewModel: AdminPanelViewModel, tipoIncidenciaAsignadaRef: String, tipoIncidenciaAsignadaDisplayName: String) {
    val uiState by viewModel.uiState.collectAsState()
    val rol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
    val esAutoridad = rol == "COMUNAL" || rol == "GENERAL" || rol == "SEGURIDAD_ADMIN" || rol == "DIRECCION_DAO" || rol == "SALVAVIDAS"
    
    // Estado interno para las pestañas: 0 = Patrullas, 1 = Sectores/Cuadrantes
    var activeTab by remember { mutableStateOf(0) }
    var filtroTipoLocal by remember { mutableStateOf("TODOS") }

    if (uiState.showAgregarPatrullaModal) {
        AgregarPatrullaModal(
            onDismiss = { viewModel.onHideAgregarPatrullaModal() },
            onConfirm = { nombre, rut, email, contrasena ->
                viewModel.onCrearNuevaPatrulla(nombre, rut, email, contrasena)
            }
        )
    }
    if (uiState.showAgregarSectorModal) {
        AgregarSectorModal(
            onDismiss = { viewModel.onHideAgregarSectorModal() },
            onConfirm = { nombre -> viewModel.onCrearNuevoSector(nombre) }
        )
    }

    Div({
        style {
            display(DisplayStyle.Flex); width(100.percent); backgroundColor(Color("#1976D2"))
            property("border-bottom", "2px solid #1565C0")
        }
    }) {
        Div({
            style {
                width(15.percent); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); padding(16.px); boxSizing("border-box")
            }
        }) {
            Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                Img(src = "logo_icon.svg", attrs = { style { height(120.px) } })
                H2({ style { fontSize(24.px); color(Color.white); margin(0.px) } }) {
                    Span({ style { fontWeight("normal") } }) { Text("Linea") }
                    Span({ style { fontWeight("bold") } }) { Text("Muni") }
                }
                P(attrs = { style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); margin(0.px) } }) { Text("SMART CITY") }
            }
        }

        Div({
            style {
                width(85.percent); padding(32.px); display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column); gap(24.px); boxSizing("border-box")
            }
        }) {
            H1({ style { color(Color.white); fontSize(32.px); fontWeight(700); textAlign("center"); margin(0.px) } }) { 
                Text(if (activeTab == 0) "GESTIÓN DE PATRULLAS" else "GESTIÓN DE CUADRANTES (PLAN CARABINEROS)") 
            }
            
            // --- BARRA DE ACCIONES Y PESTAÑAS ---
            Div({
                style {
                    display(DisplayStyle.Flex); gap(16.px); alignItems(AlignItems.Center)
                    backgroundColor(Color.white); padding(12.px); borderRadius(12.px)
                }
            }) {
                // Selector de Pestañas (Solo visible para Alcalde/General)
                if (esAutoridad) {
                    Div({ style { display(DisplayStyle.Flex); gap(8.px); backgroundColor(Color("#EEE")); padding(4.px); borderRadius(8.px) } }) {
                        Button(attrs = { 
                            onClick { activeTab = 0 }
                            style {
                                padding(8.px, 16.px); borderRadius(6.px); cursor("pointer")
                                backgroundColor(if (activeTab == 0) Color("#1976D2") else Color.transparent)
                                property("color", if (activeTab == 0) "white" else "black")
                                fontWeight("bold"); border(0.px)
                            }
                        }) { Text("👥 PATRULLAS") }

                        Button(attrs = { 
                            onClick { activeTab = 1 }
                            style {
                                padding(8.px, 16.px); borderRadius(6.px); cursor("pointer")
                                backgroundColor(if (activeTab == 1) Color("#1976D2") else Color.transparent)
                                property("color", if (activeTab == 1) "white" else "black")
                                fontWeight("bold"); border(0.px)
                            }
                        }) { Text("🗺️ CUADRANTES") }
                    }
                }

                // --- 🗺️ BOTÓN VER PLANO ---
                Button(attrs = {
                    onClick { viewModel.onShowPlanCuadranteModal() }
                    style {
                        padding(10.px, 20.px); backgroundColor(Color("#1A73E8")); color(Color.white)
                        borderRadius(8.px); cursor("pointer"); fontWeight("bold"); border(0.px)
                        marginRight(16.px)
                    }
                }) { Text("🗺️ VER PLANO") }

                // --- 🔍 FILTRO DE ESPECIALIDAD (Solo para Patrullas) ---
                if (activeTab == 0 && (rol == "COMUNAL" || rol == "GENERAL" || rol == "DIRECCION_DAO" || rol == "OPERADORA" || rol == "SOCIAL_ADMIN" || rol == "SEGURIDAD_ADULTO_MAYOR" || rol == "EMERGENCIA_CARRETERA")) {
                    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px); backgroundColor(Color("#F5F5F5")); padding(6.px, 12.px); borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#DDD")) } }) {
                        Label(attrs = { style { fontWeight("bold"); fontSize(14.px); color(Color("#555")) } }) { Text("Filtrar Servicio:") }
                        Select(attrs = {
                            style { padding(6.px); borderRadius(4.px); border(1.px, LineStyle.Solid, Color("#CCC")); fontSize(14.px); backgroundColor(Color.white) }
                            onChange { event -> filtroTipoLocal = event.target.value }
                        }) {
                            Option("TODOS") { Text("Todos los servicios") }
                            uiState.tiposIncidencia.forEach { tipo ->
                                val disp = tipo.nombreDisplay ?: tipo.nombre
                                Option(tipo.id, attrs = { if (tipo.id == filtroTipoLocal) selected() }) { Text(disp) }
                            }
                        }
                    }
                }

                Div({ style { flex(1) } })

                // Botones dinámicos según pestaña y rol
                if (activeTab == 0) {
                    // Solo roles operativos o autoridad crean patrullas
                    if (rol != "OPERADORA" && rol != "OPERADOR_DRON" && rol != "OPERADOR_CAMARAS") {
                        Button(attrs = {
                            onClick { viewModel.onShowAgregarPatrullaModal() }
                            style {
                                padding(10.px, 20.px); backgroundColor(Color("#34A853")); color(Color.white)
                                borderRadius(8.px); cursor("pointer"); fontWeight("bold"); border(0.px)
                            }
                        }) { Text("+ Nueva Patrulla") }
                    }
                } else if (rol == "COMUNAL" || rol == "GENERAL") {
                    Button(attrs = {
                        onClick { viewModel.onShowAgregarSectorModal() }
                        style {
                            padding(10.px, 20.px); backgroundColor(Color("#6A1B9A")); color(Color.white)
                            borderRadius(8.px); cursor("pointer"); fontWeight("bold"); border(0.px)
                        }
                    }) { Text("+ Nuevo Cuadrante") }
                }


                Button(attrs = {
                    onClick { viewModel.onGestionPatrullasBackClicked() }
                    style {
                        padding(10.px, 20.px); backgroundColor(Color("#FB8C00")) // 🟧 NARANJA
                        color(Color.white); borderRadius(8.px); cursor("pointer"); fontWeight("bold"); border(0.px)
                    }
                }) { Text("Volver al Panel") }
            }
        }
    }

    Div({ style { padding(24.px); backgroundColor(Color("#1976D2")); minHeight(70.vh) } }) {
        if (uiState.isLoading) {
            P({ style { color(Color.white); fontSize(24.px); textAlign("center") } }) { Text("Sincronizando Mando...") }
        } else {
            if (activeTab == 0) {
                RenderTablaPatrullas(uiState, viewModel, tipoIncidenciaAsignadaRef, tipoIncidenciaAsignadaDisplayName, filtroTipoLocal)
            } else {
                RenderTablaSectores(uiState, viewModel)
            }
        }
    }
}

@Composable
private fun RenderTablaPatrullas(
    uiState: AdminPanelUiState,
    viewModel: AdminPanelViewModel,
    tipoRef: String,
    tipoDisplay: String,
    filtroLocal: String = "TODOS"
) {
    Table({
        style { width(100.percent); property("border-collapse", "collapse"); backgroundColor(Color.white); borderRadius(12.px); property("overflow", "hidden") }
    }) {
        Thead {
            Tr({ style { backgroundColor(Color("#F8F9FA")) } }) {
                listOf("Funcionario", "Especialidad", "Estado", "Cuadrante Actual", "Re-Asignar", "Acciones").forEach {
                    Th({ style { padding(16.px); textAlign("left"); property("border-bottom", "1px solid #EEE") } }) { Text(it) }
                }
            }
        }
        Tbody {
            val miRol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
            
            // Función auxiliar para normalizar texto (Quitar tildes y basura)
            fun String.limpiar(): String = this.uppercase()
                .replace("Á", "A").replace("É", "E").replace("Í", "I").replace("Ó", "O").replace("Ú", "U")
                .replace("_", " ").trim()

            val filtradas = uiState.solucionadores.filter { sol ->
                val sName = (sol.tipoIncidenciaAsignadoDisplayName ?: "").limpiar()
                val sRef = (sol.tipoIncidenciaAsignadoRef ?: "").limpiar()
                val miRolLimpio = miRol.limpiar().replace(" ADMIN", "")
                
                // 1. Filtro por Rango (Jerarquía)
                val matchRol = when {
                    miRol == "COMUNAL" || miRol == "GENERAL" || miRol == "OPERADORA" -> true
                    miRol == "DIRECCION_DAO" -> sName.contains("DAO") || sName.contains("DIRECCION") || sName.contains("BASURA") || sName.contains("ILUMINA") || sName.contains("BACHE") || sName.contains("SEMAFORO") || sName.contains("AUTO")
                    miRol == "SEGURIDAD_ADMIN" -> sName.contains("SEGURIDAD") || sRef.contains("SEGURIDAD")
                    else -> sName.contains(miRolLimpio) || sRef.contains(miRolLimpio)
                }
                
                // 2. Filtro por Contexto (Desde qué botón se entró)
                val matchContexto = if (tipoRef.isNotEmpty() && tipoRef != "TODOS") {
                    (sol.tipoIncidenciaAsignadoRef ?: "").lowercase().contains(tipoRef.lowercase())
                } else true

                // 3. 🛡️ NUEVO: Filtro Local Dinámico
                val matchFiltroLocal = if (filtroLocal != "TODOS") {
                    sol.tipoIncidenciaAsignadoRef == filtroLocal
                } else true
                
                matchRol && matchContexto && matchFiltroLocal
            }

            filtradas.forEach { sol ->
                Tr({ style { property("border-bottom", "1px solid #EEE") } }) {
                    Td({ style { padding(16.px) } }) { 
                        B { Text(sol.nombre ?: "N/A") } 
                        Br(); Span({ style { fontSize(11.px); color(Color.gray) } }) { Text(sol.email ?: "") }
                    }
                    Td({ style { padding(16.px) } }) { Text(sol.tipoIncidenciaAsignadoDisplayName ?: "GENERAL") }
                    Td({ style { padding(16.px) } }) {
                        val color = if (sol.estaActivo) "#4CAF50" else "#F44336"
                        Span({ style { color(Color(color)); fontWeight("bold") } }) { Text(if (sol.estaActivo) "ACTIVO" else "OFF") }
                    }
                    Td({ style { padding(16.px) } }) { Text(sol.sectorAsignado ?: "GENERAL") }
                    Td({ style { padding(16.px) } }) {
                        Select(attrs = {
                            style { padding(8.px); borderRadius(4.px) }
                            if (miRol == "OPERADORA") disabled() // 🛡️ RESTRICCIÓN DE MANDO: Solo lectura
                            onChange { event ->
                                viewModel.onAsignarSector(sol.uidAuth!!, event.target.value, sol.tipoIncidenciaAsignadoRef!!, sol.tipoIncidenciaAsignadoDisplayName!!)
                            }
                        }) {
                            Option("GENERAL") { Text("Cambiar Cuadrante...") }
                            uiState.sectores.filter { it.estaActivo }.forEach { sec ->
                                Option(sec.nombre, attrs = { if (sol.sectorAsignado == sec.nombre) selected() }) { Text(sec.nombre) }
                            }
                        }
                    }
                    Td({ style { padding(16.px) } }) {
                        Div({ style { display(DisplayStyle.Flex); gap(8.px) } }) {
                            // ✏️ EDITAR NOMBRE DE PATRULLA
                            Button(attrs = {
                                onClick {
                                    val nuevo = window.prompt("Nuevo nombre para el funcionario:", sol.nombre ?: "")
                                    if (!nuevo.isNullOrBlank()) viewModel.onActualizarNombreSolucionador(sol.uidAuth!!, nuevo)
                                }
                                style { padding(6.px); backgroundColor(Color("#1A73E8")); color(Color.white); borderRadius(4.px); cursor("pointer") }
                            }) { Text("✏️") }

                            Button(attrs = { 
                                onClick { viewModel.onCambiarEstadoSolucionador(sol.uidAuth!!, sol.estaActivo) }
                                style { padding(6.px); borderRadius(4.px); cursor("pointer") }
                            }) { Text(if (sol.estaActivo) "💤" else "⚡") }

                            Button(attrs = { 
                                onClick { if (window.confirm("¿Eliminar patrulla?")) viewModel.onEliminarSolucionador(sol.uidAuth!!) }
                                style { padding(6.px); borderRadius(4.px); backgroundColor(Color.red); color(Color.white) }
                            }) { Text("🗑️") }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun RenderTablaSectores(uiState: AdminPanelUiState, viewModel: AdminPanelViewModel) {
    Table({
        style { width(100.percent); property("border-collapse", "collapse"); backgroundColor(Color.white); borderRadius(12.px); property("overflow", "hidden") }
    }) {
        Thead {
            Tr({ style { backgroundColor(Color("#F8F9FA")) } }) {
                listOf("Nombre del Cuadrante", "Tipo de Territorio", "Estado", "Acciones").forEach {
                    Th({ style { padding(16.px); textAlign("left"); property("border-bottom", "1px solid #EEE") } }) { Text(it) }
                }
            }
        }
        Tbody {
            uiState.sectores.sortedBy { it.nombre }.forEach { sector ->
                Tr({ style { property("border-bottom", "1px solid #EEE") } }) {
                    Td({ style { padding(16.px) } }) { B { Text(sector.nombre) } }
                    Td({ style { padding(16.px) } }) { Text(sector.tipoDisplay) }
                    Td({ style { padding(16.px) } }) {
                        val color = if (sector.estaActivo) "#4CAF50" else "#F44336"
                        Span({ style { color(Color(color)); fontWeight("bold") } }) { Text(if (sector.estaActivo) "OPERATIVO" else "SUSPENDIDO") }
                    }
                    Td({ style { padding(16.px) } }) {
                        val miRol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
                        val tienePermisoMando = miRol == "COMUNAL" || miRol == "GENERAL"

                        Div({ style { display(DisplayStyle.Flex); gap(12.px) } }) {
                            // EDITAR
                            Button(attrs = {
                                if (!tienePermisoMando) disabled()
                                onClick {
                                    val nuevo = window.prompt("Nuevo nombre para el sector:", sector.nombre)
                                    if (!nuevo.isNullOrBlank()) viewModel.onActualizarNombreSector(sector.id, nuevo)
                                }
                                style { 
                                    padding(8.px); backgroundColor(if(tienePermisoMando) Color("#1A73E8") else Color.gray)
                                    color(Color.white); borderRadius(4.px); cursor(if(tienePermisoMando) "pointer" else "not-allowed") 
                                }
                            }) { Text("✏️") }
                            
                            // ACTIVAR/DESACTIVAR
                            Button(attrs = {
                                if (!tienePermisoMando) disabled()
                                onClick { viewModel.onCambiarEstadoSector(sector.id, sector.estaActivo) }
                                style { 
                                    padding(8.px); backgroundColor(if (!tienePermisoMando) Color.gray else if (sector.estaActivo) Color("#ED8936") else Color("#4CAF50"))
                                    color(Color.white); borderRadius(4.px); cursor(if(tienePermisoMando) "pointer" else "not-allowed") 
                                }
                            }) { Text(if (sector.estaActivo) "OFF" else "ON") }

                            // ELIMINAR
                            Button(attrs = {
                                if (!tienePermisoMando) disabled()
                                onClick { viewModel.onEliminarSector(sector.id) }
                                style { 
                                    padding(8.px); backgroundColor(if(tienePermisoMando) Color.red else Color.gray)
                                    color(Color.white); borderRadius(4.px); cursor(if(tienePermisoMando) "pointer" else "not-allowed") 
                                }
                            }) { Text("🗑️") }
                        }
                    }
                }
            }
        }
    }
}
